import { render, staticRenderFns } from "./SidebarBlockEdit.vue?vue&type=template&id=fb70f1b6&scoped=true"
import script from "./SidebarBlockEdit.vue?vue&type=script&lang=ts"
export * from "./SidebarBlockEdit.vue?vue&type=script&lang=ts"
import style0 from "./SidebarBlockEdit.vue?vue&type=style&index=0&id=fb70f1b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb70f1b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb70f1b6')) {
      api.createRecord('fb70f1b6', component.options)
    } else {
      api.reload('fb70f1b6', component.options)
    }
    module.hot.accept("./SidebarBlockEdit.vue?vue&type=template&id=fb70f1b6&scoped=true", function () {
      api.rerender('fb70f1b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/SidebarBlockEdit.vue"
export default component.exports